/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:64a8b43f-adca-48a5-9ec9-6b11fa228ada",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_t2bh7UgaW",
    "aws_user_pools_web_client_id": "1c04tfpm81ueu1at61bk6mc9bq",
    "oauth": {
        "domain": "automatic-ease-two-prod.auth.us-east-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 12,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_content_delivery_bucket": "prodworkspace-20260602081937-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://dtky3wgj1006q.cloudfront.net",
    "aws_user_files_s3_bucket": "automatic-nj-knights-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
